import {Component, OnInit} from '@angular/core';
import {ImageService} from '../../_services/api/image.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ImageModelChooser} from './image-model-chooser/image-model-item/image-model-item.component';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss', '../../../settings.scss']
})
export class SettingsComponent implements OnInit {
  muteSettings: ImageModelChooser = {img: 'mute.svg', id: 'mute', isSelected: false, name: 'Mute'};
  loading: boolean;
  userImageSettings: any = {};
  disabledButton: boolean = true;
  constructor(public imageService: ImageService, private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.loading = true;
    this.imageService.getUserSettings().subscribe(res => {
      this.userImageSettings = res;
      this.muteSettings.isSelected = res.video.sound;
      this.muteSettings.name = res.video.sound ? 'Sound: on' : 'Sound: off';
      this.loading = false;
    });
  }

  onSettingsChange(event, key) {
    this.userImageSettings[key].model = event;
    this.disabledButton = false;
  }

  save() {
    this.loading = true;
    this.userImageSettings.video.sound = this.muteSettings.isSelected;
    this.imageService.saveUserSettings(this.userImageSettings).subscribe(res => {
      this.disabledButton = true;
      this.loading = false;
      this.snackBar.open('Settings has been saved.', 'close', {
        duration: 5000,
      });
    });
  }

  selectedModel(item: ImageModelChooser) {
    this.disabledButton = false;
    this.muteSettings.isSelected = !this.muteSettings.isSelected;
    this.muteSettings.name = this.muteSettings.isSelected ? 'Sound: on' : 'Sound: off';
  }

}
